import { render, staticRenderFns } from "./AddressInconsistencyAlert.vue?vue&type=template&id=f90111c4&"
import script from "./AddressInconsistencyAlert.vue?vue&type=script&lang=ts&"
export * from "./AddressInconsistencyAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AddressInconsistencyAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/did-homepage/did-homepage/src/components/Button.vue').default,Dialog: require('/home/runner/work/did-homepage/did-homepage/src/components/Dialog.vue').default})
